import { createContext, useContext, useState } from 'react';

export const DsRequestContext = createContext();

export const DsRequestProvider = ({ children }) => {
    const [value, setValue] = useState();
    const [dsType, setDsType] = useState();
    const [companyId, setCompanyId] = useState('');
    const [logo, setLogo] = useState();
    const [previewLang, setPreviewLang] = useState('TH');
    const [previewLangTab2, setPreviewLangTab2] = useState('TH');
    const values = {
        value,
        setValue,
        logo,
        setLogo,
        dsType,
        setDsType,
        previewLang,
        setPreviewLang,
        companyId,
        setCompanyId,
        previewLangTab2,
        setPreviewLangTab2,
    };
    return (
        <DsRequestContext.Provider value={values}>
            {children}
        </DsRequestContext.Provider>
    );
};

export const useDsRequestContext = () => useContext(DsRequestContext);
